import React, { useState, useEffect, useRef } from 'react'
import BackLogo from '../../../../images/rewampimages/Chevron.png'
import moment from 'moment';
import { getDashboardSummaryByReport, getDashboardDetailsByReport, DownloadDashboardDetailsByReport } from '../AdminActionCreator.component';
import Loader from '../../../presentationals/Loader/Loader.component'
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell, Pie, PieChart } from 'recharts';
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';
import TocIcon from '@mui/icons-material/Toc';
import TableChartIcon from '@mui/icons-material/TableChart';

const chartcolor = ['#06d6a0', '#118ab2', '#073b4c', '#ffd166', '#f72585', '#4cc9f0', '#7209b7', '#f77f00', '#fcbf49', '#d62828', '#003566']
const ItemsPerPage = 10;

const tabStyle = {
    padding: '8px 16px',
    fontWeight: '500',
    borderRadius: '8px',
    border: 'none'
}

const labelStyle = {
    fontSize: '14px',
    fontWeight: '500', color: '#374151', marginBottom: '8px'
}

const inputStyle = {
    width: "100%",
    padding: '12px 16px',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    outline: 'none'
}

const cardStyle = {
    padding: '24px',
    borderRadius: '12px',
    cursor: 'pointer ',
    boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"
}

const colorScheme = {
    "approved": {
        color: "#15803d",
        backgroundColor: '#f0fdf4',
        border: '1px solid #bbf7d0'
    },
    "communicated": {
        color: "#4338ca",
        backgroundColor: '#eef2ff',
        border: '1px solid #c7d2fe'
    },
    "disbursed": {
        color: "#047857",
        backgroundColor: '#ecfdf5',
        border: '1px solid #a7f3d0'
    },
    "expired": {
        color: "#b91c1c",
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca'
    },
    "loan under process": {
        color: "#1d4ed8",
        backgroundColor: '#eff6ff',
        border: '1px solid #bfdbfe'
    },
    "new lead": {
        color: "#1d4ed8",
        backgroundColor: '#eff6ff',
        border: '1px solid #bfdbfe'
    },
    "ongoing": {
        color: "#15803d",
        backgroundColor: '#f0fdf4',
        border: '1px solid #bbf7d0'
    },
    "paid": {
        color: "#15803d",
        backgroundColor: '#f0fdf4',
        border: '1px solid #bbf7d0'
    },
    "payment overdue": {
        color: "#c2410c",
        backgroundColor: '#fff7ed',
        border: '1px solid #fed7aa'
    },
    "pending": {
        color: "#b45309",
        backgroundColor: '#fffbeb',
        border: '1px solid #fde68a'
    },
    "permanent reject": {
        color: "#b91c1c",
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca'
    },
    "received": {
        color: "#0f766e",
        backgroundColor: '#f0fdfa',
        border: '1px solid #99f6e4'
    },
    "rejected": {
        color: "#b91c1c",
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca'
    },
    "Grand Total": {
        color: "#334155",
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0'
    },
}

const differenceDate = () => {
    let d = new Date()
    let todaysDate = d.getDate();
    return todaysDate - 1
}

const InitalDate = (type) => {
    const FirstDay = moment().subtract(differenceDate(), 'days');
    if (type === 'fromDate') {
        const fromdate = FirstDay.format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'toDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }
}

export default function DashboardNewContainer({ pageViewHandler }) {
    const dispatch = useDispatch();
    const { fromDate, toDate } = useSelector(state => state.FilterReduce.commonFilters);
    const bottomRef = useRef(null);
    const [viewTab, setViewTab] = useState("Grand Total");
    const [SummaryData, setSummaryData] = useState([])
    const [loader, setLoader] = useState(false)
    const [selectedLabel, setSelectedLabel] = useState("")
    const [selectedlist, setSelectedList] = useState([])
    const [currentPage, setcurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [payload, setPayload] = useState({
        sDate: fromDate,
        eDate: toDate,
    })


    useEffect(() => {
        const obj = {
            sDate: fromDate,
            eDate: toDate,
        }
        setPayload(obj)
        getDashboardSummaryByReportFn(obj)

    }, [fromDate, toDate]);


    const [apexState, setApexState] = useState({ data: [], color: [] })

    const [tabView, setTabView] = useState("tab")

    const handleTab = (type) => {
        setViewTab(type)
        handleTabView("tab", type)
        setSelectedList([])
        setTotalPages(1)
        setcurrentPage(1)
        setSelectedLabel("")
    }

    const handleDate = (e, type) => {
        if (type == "sDate") {
            dispatch({ type: FILTER_ACTION, payload: { fromDate: e.target.value } });

        } else {
            dispatch({ type: FILTER_ACTION, payload: { toDate: e.target.value } });
        }
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const handleFilter = () => {
        getDashboardSummaryByReportFn(payload)
        setSelectedLabel("")
    }

    const handleReload = () => {
        getDashboardSummaryByReportFn(payload)
        setSelectedLabel("")
    }

    const handleTabclick = (data) => {
        setSelectedLabel(data)
        getDashboardDetailsByReportFn(data)
    }

    const handleBarClick = (data, index) => {
        const newData = SummaryData?.filter((el) => el?.status_label == data?.payload?.status_label)
        // console.log("new", SummaryData?.filter((el) => el?.status_label == data?.payload?.status_label), SummaryData, data)
        setSelectedLabel(newData?.[0])
        getDashboardDetailsByReportFn(newData?.[0])

    };

    const closeTable = () => {
        setSelectedLabel("")
    }

    useEffect(() => {
        getDashboardSummaryByReportFn(payload)
    }, [])

    const getDashboardSummaryByReportFn = (data) => {

        setLoader(true)
        getDashboardSummaryByReport(data?.sDate, data?.eDate, callback => {
            setLoader(false)
            setSummaryData(callback || [])
            closeTable()
        })
    }
    const getDashboardDetailsByReportFn = (d) => {
        setLoader(true)
        const newTab = viewTab == "Grand Total" ? "" : viewTab
        getDashboardDetailsByReport(newTab, d?.status_label, payload?.sDate, payload?.eDate, callback => {
            setLoader(false)
            // console.log("call", callback);
            setSelectedList(callback || [])
            setTotalPages(Math.ceil(callback?.length / ItemsPerPage))
            setcurrentPage(1)
            setTimeout(() => {
                scrollToBottom()
            }, 300)
        })
    }

    const getCurrentData = (data) => {
        if (!selectedLabel) return [];
        const startIndex = (currentPage - 1) * ItemsPerPage;
        return data.slice(startIndex, startIndex + ItemsPerPage);
    };

    const scrollToBottom = () => {
        setTimeout(() => {
            bottomRef.current.scrollIntoView({ behavior: 'smooth' });
        }, 300)
    };

    const handleDownload = () => {
        setLoader(true)
        const newTab = viewTab == "Grand Total" ? "" : viewTab
        DownloadDashboardDetailsByReport(newTab, selectedLabel?.status_label, payload?.sDate, payload?.eDate, callback => {
            setLoader(false)

        })
    }


    const handleTabView = (type, viewType) => {
        setTabView(type)
        if (type === "graph") {
            let dataObj = [];
            let colorobj = [];

            SummaryData && SummaryData?.length > 0 ? SummaryData?.forEach((v, i) => {
                colorobj.push(colorScheme?.[v?.status_label]?.color || '#666666')
                // console.log("v", v, viewTab)
                const obj = {
                    name: v?.status_label?.charAt(0)?.toUpperCase() + v?.status_label?.slice(1)
                    , value: Number(v?.[viewType == "Grand Total" ? "total" : viewType == "bullet_loan" ? "bullet_loan" : "all_loan"]) || 0,
                    status_label: v?.status_label
                }

                dataObj.push(obj)
            }) : [];

            // console.log("data", dataObj)

            setApexState({ data: dataObj, color: chartcolor })
        }
    }

    const customTooltip = ({ active, payload }) => {
        // const { name, value } = payload?.[0]?.payload;

        if (active && payload?.length) {
            const { name, value } = payload[0].payload;
            return (
                <div
                    style={{
                        background: '#333',
                        color: '#fff',
                        padding: '8px 12px',
                        borderRadius: '6px',
                        fontSize: '13px',
                    }}
                >
                    <div><strong>{name}</strong></div>
                    <div>Value: {value.toLocaleString()}</div>
                </div>
            );
        }
        return null;
    };

    return (
        <>
            <div style={{ background: '#f9fafb', marginTop: '-10px' }}>
                {/* <div style={{ background: '#efefef', marginTop: '-10px' }}> */}
                {loader ?
                    <Loader />
                    : ''}
                <div className="container-fluid">
                    <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className='' style={{ marginTop: '10px', marginBottom: window.innerWidth > 1800 ? '100px' : '10px', display: 'inline-flex', alignItems: 'center' }} onClick={(e) => pageViewHandler(e, 'landingPage')}>
                            <img src={BackLogo} alt="" width={'35%'} style={{ marginRight: '10px', cursor: 'pointer' }} />
                            <h5 style={{ cursor: 'pointer' }}>Back</h5>
                        </div>
                        {/* <div>
                            <h3 style={{ color: '#006c67', margin: '0' }}>Dashboard</h3>
                        </div>
                        <div></div> */}
                    </div>

                </div>
                <div className="container-fluid" style={{ marginTop: '20px' }}>
                    <div style={{ background: '#fff', borderRadius: '12px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)', padding: '24px', marginBottom: '24px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', flexShrink: '0', gap: '10px' }}>
                                <button style={{ ...tabStyle, background: viewTab == "Grand Total" ? "#111827" : "#f3f4f6", color: viewTab == "Grand Total" ? "#fff" : "#000" }} onClick={(e) => handleTab("Grand Total")}>All</button>
                                <button style={{ ...tabStyle, background: viewTab == "bullet_loan" ? "#111827" : "#f3f4f6", color: viewTab == "bullet_loan" ? "#fff" : "#000" }} onClick={(e) => handleTab("bullet_loan")}>Bullet</button>
                                <button style={{ ...tabStyle, background: viewTab == "all_loan" ? "#111827" : "#f3f4f6", color: viewTab == "all_loan" ? "#fff" : "#000" }} onClick={(e) => handleTab("all_loan")}>EMI</button>
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <div className='tabss' style={{ background: '#f3f4f6', padding: '5px 10px', borderRadius: '6px', display: 'flex' }}>
                                    <button className='btn btn-primary' style={{ border: 'none', display: 'flex', alignItems: 'center', background: tabView == "tab" ? "#111827" : "#fff", color: tabView == "tab" ? "#fff" : "#000" }} onClick={() => handleTabView("tab", viewTab)}><TocIcon />&nbsp;Tabs</button>
                                    <button className='btn btn-primary' style={{ border: 'none', display: 'flex', alignItems: 'center', background: tabView == "graph" ? "#111827" : "#fff", color: tabView == "graph" ? "#fff" : "#000" }} onClick={() => handleTabView("graph", viewTab)}><TableChartIcon /> &nbsp;Graph</button>
                                </div>
                                <button className='btn btn-primary' style={{ ...tabStyle, background: "#267dff", color: "#fff" }} onClick={() => handleReload()}>Reload</button>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '30px' }}>
                                <label htmlFor="" style={labelStyle}>Select Status Change Start Date</label>
                                <input type='date' value={payload.sDate} style={inputStyle} onChange={(e) => handleDate(e, "sDate")} />
                            </div>
                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '30px' }}>
                                <label htmlFor="" style={labelStyle}>Select Status Change End Date</label>
                                <input type='date' value={payload.eDate} style={inputStyle} onChange={(e) => handleDate(e, "eDate")} />
                            </div>
                            <div className="col-sm-2 col-xs-12" style={{ marginTop: '30px' }}>
                                <button className='btn btn-primary' style={{ marginTop: '26px', padding: '12px' }} onClick={() => handleFilter()}>Apply</button>
                            </div>
                        </div>

                    </div>

                    {
                        tabView == "tab" ?
                            <div className="" style={{ width: '100%', display: 'flex', flexWrap: 'wrap' }}>
                                {
                                    SummaryData?.length > 0 ? SummaryData?.map((v, id) => {
                                        return (
                                            <div style={{ width: 'calc(100% / 5)', padding: '10px', marginTop: '10px' }}>
                                                <div style={{ ...cardStyle, backgroundColor: colorScheme?.[v?.status_label]?.backgroundColor, color: colorScheme?.[v?.status_label]?.color, border: colorScheme?.[v?.status_label]?.border }} onClick={() => handleTabclick(v)}>
                                                    <div className="text-center">
                                                        <div style={{ fontSize: "30px", lineHeight: '2.25rem', fontWeight: '700', marginBottom: '8px' }}>
                                                            {v?.[viewTab == "Grand Total" ? "total" : viewTab == "bullet_loan" ? "bullet_loan" : "all_loan"]?.toLocaleString()}
                                                        </div>
                                                        <div style={{ fontSize: '14px', lineHeight: '1.25rem', fontWeight: '500', opacity: '0.8' }}>
                                                            {v?.status_label?.charAt(0)?.toUpperCase() + v?.status_label?.slice(1)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                        : ''}
                            </div>
                            : ''}
                    {
                        tabView == "graph" ?
                            <div className='row'>
                                <div className="col-sm-6 col-xs-12">
                                    <div style={{ marginBottom: '20px', height: '350px', width: '100%', background: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
                                        <ResponsiveContainer width="100%" height={320}>
                                            <BarChart
                                                width={500}
                                                height={300}
                                                data={apexState?.data}

                                                layout="vertical"
                                                margin={{
                                                    top: 5,
                                                    right: 30,
                                                    left: 50,
                                                    bottom: 5,
                                                }}
                                            >
                                                <defs>
                                                    <linearGradient id="barGradient1" x1="0" y1="0" x2="0" y2="1">
                                                        <stop offset="0%" stopColor="#223D64" stopOpacity={1} />
                                                        <stop offset="100%" stopColor="#ffffff" stopOpacity={1} />
                                                    </linearGradient>
                                                </defs>
                                                <defs>
                                                    <linearGradient id="barGradient2" x1="0" y1="0" x2="0" y2="1">
                                                        <stop offset="80%" stopColor="#6d97ae" stopOpacity={1} />
                                                        <stop offset="100%" stopColor="#ffffff" stopOpacity={1} />
                                                    </linearGradient>
                                                </defs>
                                                <CartesianGrid horizontal={false} vertical={false} />
                                                <XAxis type="number" />
                                                <YAxis dataKey="name" type="category" axisLine={false}
                                                    interval={0}
                                                    angle={-20}
                                                    dx={-5}
                                                    dy={10}
                                                    tick={{ fontSize: 12, whiteSpace: 'nowrap' }}
                                                />

                                                <Bar dataKey="value" isAnimationActive={false} onClick={handleBarClick}>
                                                    {apexState?.data?.map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={apexState?.color?.[index % apexState?.color?.length]} />
                                                    ))}
                                                </Bar>
                                                {/* <Bar dataKey="value" isAnimationActive={false} fill="url(#barGradient2)" onClick={handleBarClick}> */}

                                                {/* </Bar> */}
                                                <Tooltip content={customTooltip} />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <div style={{ marginBottom: '20px', height: '350px', width: '100%', background: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
                                        <ResponsiveContainer width="100%" height={320}>
                                            <PieChart
                                                width={500}
                                                height={300}

                                            >

                                                <Pie data={apexState?.data} dataKey="value" cx="50%" cy="50%" outerRadius={140}
                                                    onClick={handleBarClick} >
                                                    {apexState?.data?.map((entry, index) => (
                                                        <Cell
                                                            key={`cell-${index}`}
                                                            fill={apexState?.color?.[index % apexState?.color?.length] || '#8884d8'}
                                                        />
                                                    ))}
                                                </Pie>
                                                <Tooltip content={customTooltip} />
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                            </div>
                            : ''}

                    {
                        selectedLabel !== "" ?
                            <div style={{ marginTop: '20px', background: '#fff', borderRadius: '12px', boxShadow: ' 0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -4px rgba(0, 0, 0, 0.1)', border: '1px solid #e5e7eb', borderRadius: '0.75rem' }} ref={bottomRef}>

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px', borderBottom: '1px solid #e5e7eb', background: '#fff', borderTopLeftRadius: '0.75rem', borderTopRightRadius: '0.75rem' }}>
                                    <div className="header-left">
                                        <h3 style={{ margin: '0', fontSize: '18px' }}>
                                            {selectedLabel?.status_label?.charAt(0)?.toUpperCase() + selectedLabel?.status_label?.slice(1)} ({selectedLabel?.["total"]?.toLocaleString()})
                                        </h3>

                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>

                                        <button onClick={() => handleDownload()}><DownloadIcon style={{ width: '20px', height: '20px' }} /></button>
                                        <button onClick={() => closeTable()}><CloseIcon style={{ width: '20px', height: '20px' }} /></button>
                                    </div>
                                </div>


                                <div className="loan_table_new">
                                    <table >
                                        <thead >
                                            <tr>
                                                {
                                                    selectedlist?.length > 0 && Object.keys(selectedlist)?.length > 0 ? Object.keys(selectedlist?.[0])?.map((value, id) => {
                                                        if (value == "Application Id" || value == "Name" || value == "Mobile No." || value == "Email ID" || value == "Status") {
                                                            return (
                                                                <th>{value && value?.includes("_") ? value?.replace("_", " ") : value}</th>
                                                            )
                                                        }
                                                    })
                                                        : ''}

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedlist?.length > 0 ? getCurrentData(selectedlist)?.map((loan, index) => (
                                                <tr key={index}>
                                                    {/* <td className="text-blue">{loan?.["S.no"]}</td> */}
                                                    <td style={{ color: '#267dff' }}><b>{loan?.["Application Id"]}</b></td>
                                                    <td>{loan?.["Name"]}</td>
                                                    <td style={{ color: '#606570' }}>{loan?.["Mobile No."]}</td>
                                                    <td style={{ color: '#606570' }}>{loan?.["Email ID"]}</td>
                                                    <td>
                                                        <div style={{
                                                            backgroundColor: colorScheme?.[loan.status_label]?.backgroundColor,
                                                            color: colorScheme?.[loan.status_label]?.color,
                                                            border: colorScheme?.[loan.status_label]?.border,
                                                            borderRadius: '8px', display: 'inline-block', padding: '5px 10px'
                                                        }}>
                                                            {loan.status_label?.charAt(0)?.toUpperCase() + loan.status_label?.slice(1)}
                                                        </div>
                                                    </td>


                                                </tr>
                                            )) : ""}
                                        </tbody>
                                    </table>
                                </div>


                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px', borderTop: '1px solid #e5e7eb', background: '#fff', borderBottomLeftRadius: '0.75rem', borderBottomRightRadius: '0.75rem' }}>
                                    <div className="footer-left">
                                        Showing {(currentPage - 1) * ItemsPerPage + 1} to {Math.min(currentPage * ItemsPerPage, selectedlist?.length)} of {selectedlist?.length} results
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <button
                                            onClick={() => setcurrentPage(Math.max(1, currentPage - 1))}
                                            disabled={currentPage === 1}
                                        >
                                            <ChevronLeftIcon />
                                        </button>
                                        {[...Array(Math.min(5, totalPages))].map((_, i) => {
                                            let pageNumber;
                                            if (totalPages <= 5) {
                                                pageNumber = i + 1;
                                            } else if (currentPage <= 3) {
                                                pageNumber = i + 1;
                                            } else if (currentPage >= totalPages - 2) {
                                                pageNumber = totalPages - 4 + i;
                                            } else {
                                                pageNumber = currentPage - 2 + i;
                                            }

                                            return (
                                                <button
                                                    key={i}
                                                    onClick={() => setcurrentPage(pageNumber)}
                                                    style={{
                                                        padding: '4px 10px', fontSize: '14px', borderRadius: '6px',
                                                        background: currentPage === pageNumber ? "#2563eb" : "none",
                                                        color: currentPage === pageNumber ? "white" : "#374151", margin: '0 3px'
                                                    }}

                                                >
                                                    {pageNumber}
                                                </button>
                                            );
                                        })}
                                        <button
                                            onClick={() => setcurrentPage(Math.min(totalPages, currentPage + 1))}
                                            disabled={currentPage === totalPages}
                                        >
                                            <ChevronRightIcon />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            : ''}



                </div>

            </div>
        </>
    )
}
